import Vue from 'vue'

import Router from 'vue-router'
import Head from 'vue-head'
import Landing from '@/views/Landing'
import Keywords from '@/views/Keywords'
import Results from '@/views/Results'
import Base from '@/layouts/Base'
import Test from '@/markdowns/posts/how-can-i-check-my-websites-seo-ranking.md';
import BlogEntries from '@/statics/data/blogs.json';

Vue.use(Router)

/* If you don't know about VueHead, please refer to https://github.com/ktquez/vue-head */

Vue.use(Head, {
  separator: '',
  complement: ''
})

const blogRoutes = Object.keys(BlogEntries).map(section => {
  const children = BlogEntries[section].map(child => ({
    path: child.id,
    name: child.id,
    component: () => import(`@/markdowns/${section}/${child.id}.md`),
    meta: {
      title: child.meta_title,
      metaTags: [
        {
          name: 'description',
          content: child.description
        },
      ],
      transitionName: 'slide',
      authNotRequired: true
    }
  }))
  return {
    path: `/${section}`,
    name: section,
    component: () => import('@/layouts/Blog'),
    children
  }
});


/* If you don't know about VueRouter, please refer to https://router.vuejs.org/ */

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing-layout',
      component: Base,
      children: [
        {
          path: 'home',
          name: 'home',
          component: Landing,
          alias: "/",
          meta: {
            transitionName: 'slide',
            authNotRequired: true
          },
        },
      ]
    },
    {
      path: '/analyze/:domain',
      name: 'domain',
      component: Base,
      children: [
        {
          path: 'keywords',
          name: 'keywords',
          alias: "/",
          component: Keywords,
          meta: {
            transitionName: 'slide-right',
            authNotRequired: true
          }
        },
        {
          path: 'results',
          name: 'results',
          component: Results,
          meta: {
            transitionName: 'slide-left',
            authNotRequired: true
          }
        },
      ]
    },
    { path: '/test', name: 'test', component: Test },
    ...blogRoutes,
    { path: '*', redirect: '/' }
  ]
})

/**
 * Handle user redirections
 */
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
